import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import { FormSectionProps } from '../../interfaces/form'

import FormWizard from '../wizard'
import FormField from '../../components/FormField'

const EmergencyFunds = ({ validate }: FormSectionProps) => {
  return (
    <Container maxWidth="md">
      <Box sx={{ mt: 7, mb: 12, display: 'flex' }} flexDirection="column">
        {' '}
        <FormWizard.Page validate={validate}>
          <Typography variant="h3" sx={{ mb: 4 }}>
            Do you have any emergency funds you could use if you were unable to
            work?
          </Typography>
          <FormField
            id="emergencyFunds"
            name="emergencyFunds"
            type="number"
            style={{ marginBottom: '40px' }}
            inputProps={{ type: 'number' }}
            InputProps={{
              startAdornment: (
                <span style={{ marginRight: 10, fontWeight: 600 }}>£</span>
              ),
            }}
          />
          <Typography variant="body1" fontSize={16} sx={{ mt: 8 }}>
            We're only looking for the kind of savings you can access easily and
            would be willing to use to support yourself if you were unable to
            work - not money that's set aside for anything else.
          </Typography>
        </FormWizard.Page>
      </Box>
    </Container>
  )
}

export default EmergencyFunds
